(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-checkout-to-billing', function(e) {
      e.preventDefault();
      let heading = $('.js-checkout-heading');
      let block = $('.js-checkout-step');

      heading.removeClass('gift payment').addClass('billing');
      block.removeClass('gift payment').addClass('billing');
    });

    $(document).on('click', '.js-checkout-to-gift', function(e) {
      e.preventDefault();
      let heading = $('.js-checkout-heading');
      let block = $('.js-checkout-step');

      heading.removeClass('billing payment').addClass('gift');
      block.removeClass('billing payment').addClass('gift');
    });

    $(document).on('click', '.js-checkout-to-payment', function(e) {
      e.preventDefault();
      let heading = $('.js-checkout-heading');
      let block = $('.js-checkout-step');

      heading.removeClass('billing gift').addClass('payment');
      block.removeClass('billing gift').addClass('payment');
    });

    $(document).on('input', '.js-wish-input textarea', function(e) {
      e.preventDefault();
      let input = $(this);
      let $wrapper = input.closest('.js-gift-wrapper');
      let $limitor = $wrapper.find('.js-wish-limit');
      let value = input.val();

      $limitor.html(100 - value.length);
    });

    $(document).on('input', '.js-name-input textarea', function(e) {
      e.preventDefault();
      let input = $(this);
      let $wrapper = input.closest('.js-gift-wrapper');
      let $limitor = $wrapper.find('.js-name-limit');
      let value = input.val();

      $limitor.html(100 - value.length);
    });

    const BILLING_IDS = [
      'billing_first_name',
      'billing_last_name',
      'billing_company',
      'billing_address_1',
      'billing_address_2',
      'billing_city',
      'billing_postcode',
      'billing_state',
      'billing_country',
      'billing_phone',
      'billing_email',
      'shipping_first_name',
      'shipping_last_name',
      'shipping_company',
      'shipping_address_1',
      'shipping_address_2',
      'shipping_city',
      'shipping_postcode',
      'shipping_state',
      'shipping_country',
      'shipping_phone',
    ];

    $(document).on('checkout_error', function() {
      let $errorItems = $('.woocommerce-error li');

      $errorItems.each(function() {
        var id = $(this).data('id');

        if (BILLING_IDS.includes(id)) {
          let heading = $('.js-checkout-heading');
          let block = $('.js-checkout-step');
          
          heading.removeClass('gift payment').addClass('billing');
          block.removeClass('gift payment').addClass('billing');

          return false;
        }
      });
    });

    // const reCalculateBlocks = function() {
    //   let $blocks = $('.js-checkout-block');

    //   $blocks.each(function() {
    //     let $block = $(this);
    //     let height = $block.outerHeight();

    //     $block.css('max-height', height);
    //   });
    // };

    // $(document).on('init_checkout payment_method_selected update_checkout updated_checkout applied_coupon_in_checkout removed_coupon_in_checkout checkout_error', function() {
    //   reCalculateBlocks();
    // });
    
    // $(window).resize(function() {
    //   reCalculateBlocks();
    // });

    // $(document).on('change', '.ship-to-different-address-checkbox', function() {
    //   reCalculateBlocks();
    // });
  });
})(jQuery);
